import withQueryProvider from "../../utils/withQueryProvider";
import GET_MY_COLLECTIONS from "./queries/GetMyCollections";
import { GetMyCollections } from "./queries/types/GetMyCollections";
import { useContext } from "react";
import { flatten } from "lodash";

// This component fetches collections and makes them available inside MyCollectionsContext
const {
  Context: MyCollectionsContext,
  Provider: MyCollectionsProvider,
} = withQueryProvider<GetMyCollections>(GET_MY_COLLECTIONS, {
  networkPolicy: "network-only",
  ssr: false,
});

export { MyCollectionsContext, MyCollectionsProvider };

export const useMyCollections = () => {
  const { data: myCollectionsData } = useContext(MyCollectionsContext);

  const allCollectionListingIds: number[] =
    flatten(
      myCollectionsData?.me?.collections.results.flatMap(
        (collection): number[] => collection.listingIds
      )
    ) || [];

  return { myCollectionsData, allCollectionListingIds };
};
